<template>
    <div class="ur-search-row">
        <!--
            $ver: v0.1.0
            검색 content가 들어오는 default slot입니다.
            #The default slot where search content comes in.
            -->
        <slot/>
    </div>
</template>

<script>
//ur-search-row는 SearchItem들의 열을 나누기 위한 컴포넌트입니다.
//#ur-search-row is a component to divide rows of search items.
export default {
    name: "urSearchRow"
}
</script>
